import { render, staticRenderFns } from "./square-feet.vue?vue&type=template&id=0b53a4de"
import script from "./square-feet.vue?vue&type=script&lang=js"
export * from "./square-feet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports